import hooks from '@/utils/hooks';
import { getLocalizedString } from './getLocalizedString';
import state from '@/state';

// Returns true if signup was navigated to or handled by a hook
export default function () {
    let handled = hooks.run('requestSignup', {});
    if (handled) {
        return true;
    }
    const merchantConfigParam = state.merchantConfig.signupUrl || '';
    const signupUrl = getLocalizedString(merchantConfigParam);
    if (signupUrl) {
        window.location = signupUrl;
        return true;
    }

    return false;
}